import { Box, Link, Typography } from '@mui/material';
import ReactMarkdown from 'react-markdown';

interface ChatBotMessageProps {
  message: string;
  userType: 'user' | 'bot';
}

export function ChatBotMessage({ message, userType }: ChatBotMessageProps) {
  return (
    <ReactMarkdown
      components={{
        p: ({ children }) => (
          <Typography
            variant="body2"
            component="p"
            sx={{
              lineHeight: 1.6,
              marginBottom: 1,
              marginTop: 0,
              '&:last-child': { marginBottom: 0 },
            }}
          >
            {children}
          </Typography>
        ),
        strong: ({ children }) => (
          <Typography component="strong" variant="body2" sx={{ fontWeight: 600 }}>
            {children}
          </Typography>
        ),
        em: ({ children }) => (
          <Typography component="em" variant="body2">
            {children}
          </Typography>
        ),
        h1: ({ children }) => (
          <Typography
            variant="subtitle1"
            component="h1"
            sx={{ fontWeight: 600, marginBottom: 1, marginTop: 1.5 }}
          >
            {children}
          </Typography>
        ),
        h2: ({ children }) => (
          <Typography
            variant="subtitle1"
            component="h2"
            sx={{ fontWeight: 600, marginBottom: 1, marginTop: 1.5 }}
          >
            {children}
          </Typography>
        ),
        h3: ({ children }) => (
          <Typography
            variant="body2"
            component="h3"
            sx={{ fontWeight: 600, marginBottom: 0.5, marginTop: 1 }}
          >
            {children}
          </Typography>
        ),
        ul: ({ children }) => (
          <Box
            component="ul"
            sx={{
              margin: 0,
              paddingLeft: 2.5,
              marginBottom: 1,
              '&:last-child': { marginBottom: 0 },
            }}
          >
            {children}
          </Box>
        ),
        ol: ({ children }) => (
          <Box
            component="ol"
            sx={{
              margin: 0,
              paddingLeft: 2.5,
              marginBottom: 1,
              '&:last-child': { marginBottom: 0 },
            }}
          >
            {children}
          </Box>
        ),
        li: ({ children }) => (
          <Typography
            component="li"
            variant="body2"
            sx={{
              lineHeight: 1.6,
              marginBottom: 0.5,
              '&:last-child': { marginBottom: 0 },
            }}
          >
            {children}
          </Typography>
        ),
        a: ({ children, href }) => (
          <Link
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              color: userType === 'user' ? 'inherit' : 'primary.main',
              textDecoration: 'underline',
              wordBreak: 'break-word',
              overflowWrap: 'break-word',
            }}
          >
            {children}
          </Link>
        ),
      }}
    >
      {message}
    </ReactMarkdown>
  );
}

